module.exports = __webpack_public_path__ + "static/0004-072d24c71d91a4d529ab8db565b30b09.jpg";